
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../base-error";

@Component({
  selector: "grid-component-determinant",
  templateUrl: "./grid-component-determinant.component.html",
  styles: [],
  providers: [
    ToastrService,
  ],
})
export class GridComponentDeterminantComponent extends BaseError implements OnInit, OnChanges {
  @Input() public serviceId: string;
  @Input() public gridEventName: string;
  @Input() public gridKey: string;
  @Output() public gridEventNameResponse = new EventEmitter();
  @Output() public gridKeyResponse = new EventEmitter();

  public gridEvents: any[] = [
    { key: "editGridSelectRow", name: "Grid Select Row" },
    { key: "editGridUnSelectRow", name: "Grid Unselect Row" }
  ];

  constructor(
    public toastr: ToastrService,
  ) {
    super(toastr);
  }

  public ngOnInit() {
    // Grid field is now selected in parent component's "Select field"
  }

  public gridKeyChanged(newGridKey: string) {
    this.gridKey = newGridKey;
    this.gridKeyResponse.emit(newGridKey);
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.gridEventName?.currentValue) {
      this.gridEventName = changes.gridEventName.currentValue;
    }
    if (changes.gridKey?.currentValue) {
      this.gridKey = changes.gridKey.currentValue;
    }
  }

  public gridEventNameChanged() {
    this.gridEventNameResponse.emit(this.gridEventName);
  }
}
